export function isStoredCoordinate(value) {
    if (value === undefined || value === null || value === '') return false
    return Number.isFinite(Number(value))
}

export function hasStoredItemPosition(item) {
    return isStoredCoordinate(item?.top) && isStoredCoordinate(item?.left)
}

export function hasStoredItemPositions(items = []) {
    return items.some(hasStoredItemPosition)
}
